/**
 * ERP Configuration — Master Lists.
 *
 * BD_Emergent_Prompt_19Sep2026 (B2): the Pipeline Stages / SLA Rules / Automation
 * tabs that used to live here are removed — that machinery (stale-deal SLA
 * thresholds, auto-task creation) had no real threshold-owner and its own
 * diagnostics found it firing on every record. Stage lists are now governed
 * entirely by the masters below (A3) — `lead_stages` and `opportunity_stages`
 * under "BD — Leads & Opportunities".
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import { Settings as SettingsIcon, ArrowLeft } from 'lucide-react';
import MasterListsEditor from '../../components/MasterListsEditor';

export default function ERPConfiguration() {
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6" data-testid="erp-config-page">
      <button
        onClick={() => navigate('/app/settings')}
        className="inline-flex items-center gap-2 text-xs uppercase tracking-wider font-display font-bold text-slate-500 hover:text-[#3b4872]"
        data-testid="back-to-settings"
      >
        <ArrowLeft size={14} /> Back to Settings
      </button>

      <PageHeader
        title="ERP Configuration"
        subtitle="Master dropdown lists used everywhere in the ERP — including the governed lead and opportunity stage lists."
        icon={SettingsIcon}
      />

      <MasterListsEditor />
    </div>
  );
}
